const branches = ['Teachers', 'Students', 'Sups', 'NewAdmins', 'SuperAdmin', 'Dev'];

export const normalizeProfileEmail = email =>
  String(email || '')
    .trim()
    .toLowerCase();

// Fail closed on unreadable branches. This is a client guard, not an atomic reservation.
export async function assertProfileAvailable(email, branch, currentKey, read) {
  const normalized = normalizeProfileEmail(email);
  const key = normalized.replace(/\./g, '');
  if (!normalized || /[#$\[\]/]/.test(key)) throw new Error('Некоректна email-адреса.');
  const records = await Promise.all(branches.map(async path => ({ path, snapshot: await read(`${path}/${key}`) })));
  const ownTeacher = records.find(record => record.path === 'Teachers')?.snapshot.val();
  const validOwnTeacher =
    branch === 'Teachers' &&
    currentKey === key &&
    ownTeacher?.type === 'Teacher' &&
    typeof ownTeacher.email === 'string' &&
    ownTeacher.email.toLowerCase() === normalized;
  for (const { path, snapshot } of records) {
    if (!snapshot.exists()) continue;
    if (path === branch && currentKey === key) continue;
    const data = snapshot.val();
    if (
      path === 'Sups' &&
      branch === 'Teachers' &&
      ((validOwnTeacher && data?.email == null) ||
        (typeof data?.email === 'string' && data.email.toLowerCase() === normalized)) &&
      (data.type == null || ['Teacher', 'Sups'].includes(data.type))
    )
      continue;
    throw new Error('Ця email-адреса вже пов’язана з іншим профілем. Зверніться до адміністратора.');
  }
  return { email: normalized, key };
}
